import { format, parseISO } from 'date-fns';

// Coarse treatment status (the version a referring dentist would see). Active
// cases fall back to the Plato /letter discharge signal (ongoing /
// discharge_drafted / discharged); terminal app-side case statuses override it
// (completed / referred_back / inactive) so the badge tracks what staff set in
// the app, not just Plato.
export const TREATMENT_STATUS: Record<string, { label: string; className: string }> = {
  ongoing: { label: 'Treatment ongoing', className: 'border-sky-200 bg-sky-50 text-sky-700' },
  discharge_drafted: {
    label: 'Discharge drafted',
    className: 'border-amber-200 bg-amber-50 text-amber-700',
  },
  discharged: {
    label: 'Discharged',
    className: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  },
  // Legacy key. Completed and Referred Back are one status now (Samuel, 29 Sep
  // 2026); a case the database still calls `completed` reads as Referred back.
  completed: {
    label: 'Referred back',
    className: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  },
  referred_back: {
    label: 'Referred back',
    className: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  },
  inactive: {
    label: 'Inactive',
    className: 'border-slate-200 bg-slate-50 text-slate-600',
  },
};

export const treatmentStatusMeta = (status: string | null | undefined) =>
  TREATMENT_STATUS[status ?? 'ongoing'] ?? TREATMENT_STATUS.ongoing;

// Internal endodontic stage labels (derived from appointment descriptions).
export const STAGE_LABEL: Record<string, string> = {
  consult: 'Consult',
  stage_1: 'Stage 1 — root canal start',
  stage_2: 'Stage 2 — root canal fill',
  review: 'Review',
  '6_month_review': '6-month review',
  discharge: 'Discharge',
  other: '—',
};

export const stageLabel = (stage: string | null | undefined): string | null => {
  if (!stage || stage === 'other') return null;
  return STAGE_LABEL[stage] ?? stage;
};

export const formatDay = (value: string | null): string => {
  if (!value) return '';
  try {
    return format(parseISO(value), 'd MMM yyyy');
  } catch {
    return value;
  }
};
